// extracted by mini-css-extract-plugin
export var black = "_2k-6";
export var brand = "_2k-1";
export var ddefault = "_2k-0";
export var error = "_2k-3";
export var gray = "_2k-2";
export var highContrast = "_2k-8";
export var outline = "_2k-7";
export var success = "_2k-5";
export var warning = "_2k-4";